import { graphql } from "react-relay";

export const QUERY = graphql`
	query licenses_LicensesQuery {
		...licensesTable_LicensesFragment
	}
`;
